import { render, staticRenderFns } from "./message-list-new.vue?vue&type=template&id=90d2193c&scoped=true"
import script from "./message-list-new.vue?vue&type=script&lang=ts"
export * from "./message-list-new.vue?vue&type=script&lang=ts"
import style0 from "./message-list-new.vue?vue&type=style&index=0&id=90d2193c&prod&lang=scss&scoped=true"
import style1 from "./message-list-new.vue?vue&type=style&index=1&id=90d2193c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d2193c",
  null
  
)

export default component.exports